module.exports = __webpack_public_path__ + "assets/img/media_25.e0f8b3e4.png";